import { styled, Grid, Divider } from "@mui/material";

export const StyledContainer = styled(Grid)(({ theme }) => ({ backgroundColor: theme.palette.primary.dark }));

export const StyledLeftSection = styled(Grid)({
    display: 'flex',
    alignItems: 'center',
    height: '56px'
  });

  export const StyledLogo = styled('div')(({ theme }) => ({
    fontSize: '20px',
    width: '120px',
    color: theme.palette.secondary.main,
    marginLeft: '25px'
  }));
  
  export const StyledRightSection = styled(Grid)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 56px;
  padding: 10px 15px;
`;
export const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.text.secondary,
}));